
import { Box, Button, Stack, Typography, Grid, CircularProgress, Backdrop, FormControlLabel, Radio, FormControl, FormLabel, RadioGroup, Divider, ToggleButton, ToggleButtonGroup, keyframes } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import { LoadingButton } from "@mui/lab"
import React, { useEffect, useRef, useState } from "react";
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from "formik";
import Lottie from "lottie-react";
import { FormDatePicker } from "../form/datePicker";
import FormField from "../form/formField";
import FormFileField from "../form/formFileField";
import FormSelect from "../form/formSelect";
import ModalComponent from "./modalComponent";
import addressServices from "../../services/addressServices";
import authServices from "../../services/authServices";
import { useDispatch, useSelector } from 'react-redux';
import CustomIcon from "../customIcon";
import FormAutoCompleted from "../form/formAutoComplete";
import bankServices from './../../services/bankServices';
import { useSnackbar } from "notistack";
import { saveUser } from "../../redux/reducers/userSlice";
import check from "../../animations/check.json"
import moment from "moment";
import { PhoneInput } from 'react-international-phone';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import 'react-international-phone/style.css';
import AreYouSureModal from "./areYouSureModal";
import FormCheckBox from "../form/formCheckBox";
import PanCardMessage from "./panCardMessage";
import style from './accountSetup.module.css'
import { format } from "date-fns";
import userServices from "../../services/userServices";
import logsService from "../../services/logServices";
import { InvestorActivityEventType } from "../../utils/eventTypes";
import SharedBlockChainAccCreation from "./common/SharedBlockChainAccCreation";
import { sanitizeAccountNumberInput, sanitizeIfscInput, sanitizePanInput } from "../../utils/kycSanitizers";


const VALID_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const SUPPORTED_FORMATS = ["image/png", "image/jpeg", "image/jpg","image/webp"];

const personalInfoSchemaThroughPhoneNumber = Yup.object().shape({
    // username: Yup.string().required("Username is required."),
    emailId: Yup.string().email("Please enter valid email.").required("Email is required."),
    // gender:Yup.string().required("Gender is required."),
    dob: Yup.string().required("Date of birth is required."),
    citizenShip: Yup.string().required("Citizenship is required."),
    // address:Yup.object().shape({
    //     pinCode:Yup.number().required("This field is required."),
    //     house:Yup.string().required("This field is required."),
    //     area:Yup.string().required("This field is required."),
    //     landMark:Yup.string().required("This field is required."),
    //     city:Yup.string().required("This field is required."),
    //     state:Yup.string().required("This field is required."),
    // })
});

const personalInfoSchemaThroughSocialSignIn = Yup.object().shape({
    // username: Yup.string().required("Username is required."),
    // gender:Yup.string().required("Gender is required."),
    dob: Yup.string().required("Date of birth is required."),
    citizenShip: Yup.string().required("Citizenship is required."),
    // address:Yup.object().shape({
    //     pinCode:Yup.number().required("This field is required."),
    //     house:Yup.string().required("This field is required."),
    //     area:Yup.string().required("This field is required."),
    //     landMark:Yup.string().required("This field is required."),
    //     city:Yup.string().required("This field is required."),
    //     state:Yup.string().required("This field is required."),
    // })
});

// const kycSchema = Yup.object().shape({
//     panCardNumber: Yup.string().matches(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/, "Invalid PAN number format").required("PAN No. is required."),
//     ifscCode: Yup.string().required("IFSC code is required."),
//     accNumber: Yup.number().required("Account Number is required."),
//     accType: Yup.string().required("Account Type is required."),
//     bankCheque: Yup.mixed().nullable().required("Please upload this document.").test("FILE_SIZE", "File size must be below 5MB.", value => value && value.size <= VALID_FILE_SIZE)
//         .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => value && SUPPORTED_FORMATS.includes(value.type)),
//     // aadhaar:Yup.string().required("Aadhaar No. is required.")
//     // addressProof:Yup.object().nullable().required("Please select address proof."),
//     // bankInformation:Yup.object().shape({
//     //     ifsc:Yup.string().required("IFSC code is required."),
//     //     accHolderName:Yup.string().required("Name is required."),
//     //     accNumber:Yup.number().required("Account Number is required."),
//     //     bank:Yup.string(),
//     //     branch:Yup.string(),
//     //     accType:Yup.string().required("Account Type is required."),
//     // }),
//     // panCard:Yup.mixed().nullable().required("Please upload this document.").test("FILE_SIZE", "File size must be below 5MB.", value => value && value.size <= VALID_FILE_SIZE)
//     //     .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => value && SUPPORTED_FORMATS.includes(value.type)),
//     // bankCheque:Yup.mixed().nullable().required("Please upload this document.").test("FILE_SIZE", "File size must be below 5MB.", value => value && value.size <= VALID_FILE_SIZE)
//     // .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => value && SUPPORTED_FORMATS.includes(value.type)),
//     // addressProofFront:Yup.mixed().nullable().required("Please upload this document.").test("FILE_SIZE", "File size must be below 5MB.", value => value && value.size <= VALID_FILE_SIZE)
//     //     .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => value && SUPPORTED_FORMATS.includes(value.type)),
//     // addressProofBack:Yup.mixed().nullable().test("FILE_SIZE", "File size must be below 5MB.", value => value ? value.size <= VALID_FILE_SIZE:true)
//     //     .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => value ? SUPPORTED_FORMATS.includes(value.type):true),
// })

const createManualKycSchema = (panAlreadyTaken = false) => Yup.object().shape({
    panCardNumber: panAlreadyTaken
        ? Yup.string().notRequired()
        : Yup.string().matches(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/, "Invalid PAN number format").required("PAN No. is required."),
    // ifscCode: Yup.string().required("IFSC code is required."),
    // accNumber: Yup.number().required("Account Number is required."),
    // aadhaar:Yup.string().required("Aadhaar No. is required.")
    addressProof: Yup.object().nullable().required("Please select address proof."),
    bankInformation: Yup.object().shape({
        ifsc: Yup.string()
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC format (11 characters: 4 letters, 0, then 6 alphanumeric)")
            .required("IFSC code is required."),
        accHolderName: Yup.string().required("Name is required."),
        accountNumber: Yup.string()
            .matches(/^[0-9]{9,16}$/, "Account number must be 9 to 16 digits")
            .required("Account Number is required."),
        bankName: Yup.string(),
        branch: Yup.string(),
        accountType: Yup.string().required("Account Type is required."),
    }),
    userAddress: Yup.object().shape({
        flatNo: Yup.string().required("Flat No is required."),
        area: Yup.string().required("Area is required."),
        landmark: Yup.string(),
        town: Yup.string().required("Town is required."),
        state: Yup.string().required("State is required."),
        pincode: Yup.string()
            .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits")
            .required("Pincode is required."),
    }),
    panCard: panAlreadyTaken
        ? Yup.mixed().nullable().notRequired()
        : Yup.mixed()
            .nullable()
            .test("IS_FILE_OR_STRING", "Please upload this document.", value => {
                if (!value) return false;
                if (!(value instanceof File)) return true; // Skip if it's a string (existing file URL)
                return true;
            })
            .test("FILE_SIZE", "File size must be below 5MB.", value => {
                if (!value || !(value instanceof File)) return true;
                return value.size <= VALID_FILE_SIZE;
            })
            .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => {
                if (!value || !(value instanceof File)) return true;
                return SUPPORTED_FORMATS.includes(value.type);
            }),
    bankCheque: Yup.mixed()
        .nullable()
        .test("IS_FILE_OR_STRING", "Please upload this document.", value => {
            if (!value) return false;
            if (!(value instanceof File)) return true; // Skip if it's a string (existing file URL)
            return true;
        })
        .test("FILE_SIZE", "File size must be below 5MB.", value => {
            if (!value || !(value instanceof File)) return true;
            return value.size <= VALID_FILE_SIZE;
        })
        .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => {
            if (!value || !(value instanceof File)) return true;
            return SUPPORTED_FORMATS.includes(value.type);
        }),
    addressProofFront: Yup.mixed()
        .nullable()
        .test("IS_FILE_OR_STRING", "Please upload this document.", value => {
            if (!value) return false;
            if (!(value instanceof File)) return true; // Skip if it's a string (existing file URL)
            return true;
        })
        .test("FILE_SIZE", "File size must be below 5MB.", value => {
            if (!value || !(value instanceof File)) return true;
            return value.size <= VALID_FILE_SIZE;
        })
        .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => {
            if (!value || !(value instanceof File)) return true;
            return SUPPORTED_FORMATS.includes(value.type);
        }),
})

const citizenShipSchema = Yup.object().shape({
    havingPanCard: Yup.string().required("Please select YES or NO").oneOf(["YES", "NO"], "Please select YES or NO"),
    residingInIndia: Yup.string().required("Please select YES or NO").oneOf(["residingInIndia", "notResidingInIndia"], "Please select YES or NO"),
})



export default function AccountSetupModal({ open, handleClose = () => { } }) {
    const [currentStep, setStep] = useState(1);
    const [blockchainAccountDownload, setBlockchainAccountDownload] = useState(false);
    const [blockchainAccountCreated, setBlockchainAccountCreated] = useState(false);
    const [animating, setAnimating] = useState(false);
    const [otp, setOtp] = useState("");
    const [dltName, setDltName] = useState("");
    const [otpForm, setOtpForm] = useState(false);
    const [aadhaar, setAadhaar] = useState("");
    const [refId, setRefId] = useState("");
    const [openProgressBar, setOpenProgressBar] = useState(false);
    const modelRef = useRef();
    const [sendMail, setSendMail] = useState(true);
    const [isIndian, setIsIndian] = useState("YES")
    const user = useSelector(state => state.user.data);
    const { enqueueSnackbar } = useSnackbar();

    const dispatch = useDispatch();

    useEffect(() => {
        if (user?.status === "FIRST_TIME") setStep(1);
        if (user?.status === "REGISTERED" || user?.status === "REJECTED") setStep(2);
        if (user?.status === "KYC_APPROVED") setStep(3);
    }, [user?.status]);

    useEffect(() => {
        if (animating) {
            scrollToTop();
        }
    }, [animating])

    const customHandleClose = () => {
        if (currentStep !== 3 || !blockchainAccountCreated || blockchainAccountDownload) handleClose();
        else enqueueSnackbar("Please download key details before closing!", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, autoHideDuration: 5000 })
    }

    const scrollToTop = () => {
        if (modelRef.current) {
            let modalBody = modelRef.current.querySelector('.MuiDialog-container')
            // console.log(modalBody)
            if (modalBody) {
                modalBody.scroll({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    }

    return (
        <ModalComponent slotProps={{
            root: {
                ref: modelRef
            }
        }}
            open={open}
            handleClose={customHandleClose}
            title={"Complete Account Setup"} PaperProps={{ sx: { overflow: "auto", minHeight: 'auto', minWidth: { md: 684, xs: "auto" } } }}>
            <Backdrop open={openProgressBar} sx={{ color: "#ddd", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        zIndex: (theme) => theme.zIndex.modal + 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress
                        size={75}
                        thickness={4}

                    />
                </Box>
            </Backdrop>
            <Stepper currentStep={currentStep} />
            {
                animating &&
                <Box sx={{ width: 150, margin: "auto", pt: 20 }}>
                    <Lottie onComplete={() => {
                        setAnimating(false);
                    }} animationData={check} loop={false} />
                </Box>

            }
            {
                currentStep === 1 && !animating ?
                    <PersonalInfo setStep={setStep} user={user} enqueueSnackbar={enqueueSnackbar} dispatch={dispatch} setAnimating={setAnimating} isIndian={isIndian} setIsIndian={setIsIndian} handleClose={handleClose} />
                    :
                    currentStep === 2 && !animating ?
                        <KYCForm setStep={setStep} user={user} otp={otp} refId={refId} setRefId={setRefId} setOtp={setOtp} otpForm={otpForm} setOtpForm={setOtpForm} aadhaar={aadhaar} setAadhaar={setAadhaar} openProgressBar={openProgressBar} setOpenProgressBar={setOpenProgressBar} enqueueSnackbar={enqueueSnackbar} dispatch={dispatch} handleClose={handleClose} setAnimating={setAnimating} customHandleClose={customHandleClose} />
                        :
                        currentStep === 3 && !animating ?
                            <SharedBlockChainAccCreation
                                entity={user}
                                entityType="INVESTOR"
                                customHandleClose={customHandleClose}
                                setAnimating={setAnimating}
                                setBlockchainAccountDownload={setBlockchainAccountDownload}
                                blockchainAccountCreated={blockchainAccountCreated}
                                setBlockchainAccountCreated={setBlockchainAccountCreated}
                                disableAlgorandOption={true}
                                nicknamePlaceholder="Primary Account"
                                sendMail={sendMail}
                                setSendMail={setSendMail}
                                disablePolygonOption={!user?.dltPolicy?.polygon}
                                disableMstOption={!user?.dltPolicy?.mst}
                            />
                            : ""
            }
        </ModalComponent>
    )
}

const Stepper = ({ currentStep }) => {
    const steps = ["Create Account", "Personal Details", "Complete KYC", "Create Your Digital Assets Account"];
    return (
        <Box mt={5} sx={{ width: "100%" }}>
            <Stack
                direction={"row"}
                spacing={{ xs: 0, md: 4 }}
                sx={{
                    width: "100%",
                    justifyContent: { xs: "space-between", md: "flex-start" },
                }}
            >
                {
                    steps.map((e, i) => {
                        return (
                            <Stack
                                key={e}
                                direction={"column"}
                                sx={{
                                    flex: { xs: 1, md: "0 0 auto" },
                                    minWidth: { xs: 0, md: "auto" },
                                }}
                            >
                                <Box sx={{
                                    width: "100%",
                                    position: "relative"
                                }}>
                                    <Box sx={{
                                        width: 24, height: 24,
                                        borderRadius: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        bgcolor: currentStep > i ? "success.main" : "success.light",
                                        position: "relative", zIndex: 1
                                    }}>
                                        {
                                            currentStep === i ?
                                                <Box sx={{
                                                    width: 12,
                                                    height: 12,
                                                    bgcolor: "success.main",
                                                    borderRadius: "100%",
                                                }}>
                                                </Box>
                                                :
                                                currentStep > i ?
                                                    <CustomIcon name="check" sx={{ bgcolor: "#FFF", width: 12, height: 12, }} />
                                                    : ""
                                        }
                                    </Box>
                                    {
                                        steps.length === i + 1 ? "" :
                                            <Box sx={{
                                                width: "calc(100% + 32px)",
                                                height: 4,
                                                bgcolor: currentStep > i ? "success.main" : "success.light",
                                                position: "absolute",
                                                top: "50%",
                                                left: 0,
                                                transform: "translateY(-50%)",
                                                zIndex: 0
                                            }}>
                                            </Box>
                                    }
                                </Box>
                                <Box sx={{ minWidth: { xs: 0, md: 130 }, display: { xs: currentStep === i ? "block" : "none", md: "block" } }}>
                                    <Typography variant="subtitle1" sx={{ fontSize: 12, mt: { md: 3, xs: 2 } }}>Step {i + 1}</Typography>
                                    <Typography variant="body2" sx={{ mt: 0, fontSize: { xs: 7, sm: 10 } }}>{e}</Typography>
                                </Box>
                            </Stack>
                        )
                    })
                }
                {/* <Stack direction={"column"}>
                    <Box sx={{width:24,height:24,borderRadius:"100%",bgcolor:"success.main"}}></Box>
                    <Box sx={{minWidth:130}}>
                        <Typography variant="subtitle1" sx={{fontSize:12,mt:3}}>Step 2</Typography>
                        <Typography variant="body2" sx={{mt:0}}>Complete KYC</Typography>
                    </Box>
                </Stack> */}
            </Stack>
        </Box>
    )
}

const PersonalInfo = ({ handleClose, setStep, user, enqueueSnackbar, dispatch, setAnimating, setResidingInIndia, residingInIndia, isIndian, setIsIndian }) => {

    const [phone, setPhone] = useState("")
    const [country, setCountry] = useState("")
    const [isPhoneValid, setIsPhoneValid] = useState(true)
    const [showQuestions, setShowQuestions] = useState(user?.citizenShip);

    // const genderOptions = [
    //     // {
    //     //     title:"Male",
    //     //     value:"Male",
    //     // },
    //     // {
    //     //     title:"Female",
    //     //     value:"Female",
    //     // },
    //     // {
    //     //     title:"Others",
    //     //     value:"Others",
    //     // },
    //     {
    //         title:"Mr (He/His)",
    //         value:"Mr (He/His)",
    //     },
    //     {
    //         title:"Mrs (She/Her)",
    //         value:"Mrs (She/Her)",
    //     },
    //     {
    //         title:"Ms (She/Her)",
    //         value:"Ms (She/Her)",
    //     },
    //     {
    //         title:"Dr. (He/His)",
    //         value:"Dr. (He/His)",
    //     },
    //     {
    //         title:"Dr. (She/Her)",
    //         value:"Dr. (She/Her)",
    //     },
    //     {
    //         title:"I'd rather not say",
    //         value:"Others",
    //     }
    // ];

    const citizenshipOptions = [
        {
            title: "Indian",
            value: "INDIAN",
        },
    ];

    // const stateOptions =[
    //     {
    //         "title": "Andhra Pradesh",
    //         "value": "Andhra Pradesh"
    //     },
    //     {
    //         "title": "Arunachal Pradesh",
    //         "value": "Arunachal Pradesh"
    //     },
    //     {
    //         "title": "Assam",
    //         "value": "Assam"
    //     },
    //     {
    //         "title": "Bihar",
    //         "value": "Bihar"
    //     },
    //     {
    //         "title": "Chandigarh (UT)",
    //         "value": "Chandigarh (UT)"
    //     },
    //     {
    //         "title": "Chhattisgarh",
    //         "value": "Chhattisgarh"
    //     },
    //     {
    //         "title": "Dadra and Nagar Haveli (UT)",
    //         "value": "Dadra and Nagar Haveli (UT)"
    //     },
    //     {
    //         "title": "Daman and Diu (UT)",
    //         "value": "Daman and Diu (UT)"
    //     },
    //     {
    //         "title": "Delhi",
    //         "value": "Delhi"
    //     },
    //     {
    //         "title": "Goa",
    //         "value": "Goa"
    //     },
    //     {
    //         "title": "Gujarat",
    //         "value": "Gujarat"
    //     },
    //     {
    //         "title": "Haryana",
    //         "value": "Haryana"
    //     },
    //     {
    //         "title": "Himachal Pradesh",
    //         "value": "Himachal Pradesh"
    //     },
    //     {
    //         "title": "Jammu and Kashmir",
    //         "value": "Jammu and Kashmir"
    //     },
    //     {
    //         "title": "Jharkhand",
    //         "value": "Jharkhand"
    //     },
    //     {
    //         "title": "Karnataka",
    //         "value": "Karnataka"
    //     },
    //     {
    //         "title": "Kerala",
    //         "value": "Kerala"
    //     },
    //     {
    //         "title": "Lakshadweep (UT)",
    //         "value": "Lakshadweep (UT)"
    //     },
    //     {
    //         "title": "Madhya Pradesh",
    //         "value": "Madhya Pradesh"
    //     },
    //     {
    //         "title": "Maharashtra",
    //         "value": "Maharashtra"
    //     },
    //     {
    //         "title": "Manipur",
    //         "value": "Manipur"
    //     },
    //     {
    //         "title": "Meghalaya",
    //         "value": "Meghalaya"
    //     },
    //     {
    //         "title": "Mizoram",
    //         "value": "Mizoram"
    //     },
    //     {
    //         "title": "Nagaland",
    //         "value": "Nagaland"
    //     },
    //     {
    //         "title": "Odisha",
    //         "value": "Odisha"
    //     },
    //     {
    //         "title": "Puducherry (UT)",
    //         "value": "Puducherry (UT)"
    //     },
    //     {
    //         "title": "Punjab",
    //         "value": "Punjab"
    //     },
    //     {
    //         "title": "Rajasthan",
    //         "value": "Rajasthan"
    //     },
    //     {
    //         "title": "Sikkim",
    //         "value": "Sikkim"
    //     },
    //     {
    //         "title": "Tamil Nadu",
    //         "value": "Tamil Nadu"
    //     },
    //     {
    //         "title": "Telangana",
    //         "value": "Telangana"
    //     },
    //     {
    //         "title": "Tripura",
    //         "value": "Tripura"
    //     },
    //     {
    //         "title": "Uttarakhand",
    //         "value": "Uttarakhand"
    //     },
    //     {
    //         "title": "Uttar Pradesh",
    //         "value": "Uttar Pradesh"
    //     },
    //     {
    //         "title": "West Bengal",
    //         "value": "West Bengal"
    //     }
    // ];

    const handlePhoneChange = (value, meta) => {
        const countryData = meta?.country;
        const dialCode = countryData?.dialCode || '91';

        // Parse phone number with country context to avoid wrong interpretation (e.g. 934 as country code)
        const phoneNumber = parsePhoneNumberFromString(value, countryData?.iso2 || 'IN');

        // Extracting the mobile number without the dial code
        const mobileNumber = phoneNumber ? String(phoneNumber.nationalNumber || '') : value.replace(/\D/g, '').replace(new RegExp(`^${dialCode}`), '') || '';

        setPhone(mobileNumber);
        setCountry(dialCode);

        // Validate using libphonenumber-js - handles all countries (different lengths: India 10, UK 10-11, Australia 9, etc.)
        const isValid = !phoneNumber || phoneNumber.isValid();
        setIsPhoneValid(isValid);
    };

    const formik = useFormik({
        initialValues: {
            // username: "",
            emailId: "",
            phone: "",
            dob: moment().subtract(18, "years"),
            // gender:"",
            citizenShip: "INDIAN",
            isIndian: "INDIAN",
            // address:{
            //     pinCode:"",
            //     house:"",
            //     area:"",
            //     landMark:"",
            //     city:"",
            //     state:""
            // },
        },
        validationSchema: user?.signInType === "phone" ? personalInfoSchemaThroughPhoneNumber : personalInfoSchemaThroughSocialSignIn,
        onSubmit: (v) => {
            saveDetails(v);
        },
    });


    const { errors, touched, handleSubmit, getFieldProps, values, setFieldValue, isSubmitting, setSubmitting } = formik;

    const saveDetails = async (values) => {
        if (user?.signInType !== "phone" && !phone) {
            setIsPhoneValid(false);
            return;
        }
        if (user?.signInType !== "phone" && !isPhoneValid) {
            return;
        }
        const coupon= localStorage.getItem("coupon");
        let data = {
            ...values,
            dob: values.dob.unix(),
            investorId: user._id,
            status: "FIRST_TIME",
            coupon: coupon ? coupon : null
        };
        if (user?.signInType !== "phone") {
            delete data['email']
            data['phone'] = parseInt(phone)
            data['countryCode'] = parseInt(country)
        }

        setSubmitting(true);
        try {
            const res = await authServices.savePersonalDetails(data);
            setSubmitting(false);
            if (res && res?.data?.code === 409) {
                enqueueSnackbar(res.data.message, { variant: "error" });
            } else if (res && res.success) {
                enqueueSnackbar("Personal details submitted", { variant: "success" });
                setAnimating(true)
                dispatch(saveUser(res.data));
                logsService.addLog({
                    userId: user._id,
                    event: InvestorActivityEventType.PERSONAL_DETAILS_SAVED,
                    
                })
                // setStep(1);
            } else enqueueSnackbar(res?.data?.message || "Something went wrong!", { variant: "error", autoHideDuration: 4000 });
        } catch (error) {
            console.log(error);
        }
    }

    // const getAddressFromPinCode =  async() =>{
    //     const res = await addressServices.getAddressFromPinCode(values?.address?.pinCode);
    //     if(res && res.PostOffice && res.PostOffice[0]){
    //         console.log(res.PostOffice[0])
    //         setFieldValue("address.city",res.PostOffice[0]?.District)
    //         setFieldValue("address.state",res.PostOffice[0]?.State)
    //     }
    // }

    const handleIsIndian = (event, newValue) => {
        if (newValue !== null) {
            formik.setFieldValue("isIndian", newValue);
            formik.setFieldValue("citizenShip", newValue);
        }
    };


    return (
        <Box mt={4}>

            {!showQuestions ?
                (
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Typography variant="h4">Enter Personal Information</Typography>
                            <Stack spacing={3} mt={3}>
                                {/* <FormField
                                    label={"How would you like to be called? *"}
                                    inputProps={{
                                        placeholder: "username",
                                        ...getFieldProps("username"),
                                        error: Boolean(touched.username && errors.username),
                                        helperText: touched.username && errors.username
                                    }}
                                /> */}

                                <Stack direction={{ md: "row", xs: "column" }} spacing={{ md: 3, xs: 1.5 }}>
                                    {user?.signInType === "phone" ?
                                        <Box width={{ md: "50%", xs: "100%" }}>
                                            <FormField
                                                label={"Email Address *"}
                                                inputProps={{
                                                    placeholder: "",
                                                    ...getFieldProps("emailId"),
                                                    error: Boolean(touched.emailId && errors.emailId),
                                                    helperText: touched.emailId && errors.emailId
                                                }}
                                            />
                                        </Box>
                                        :
                                        <Box width={{ md: "50%", xs: "100%" }}>
                                            <Stack direction={"column"} spacing={1}>
                                                <Typography variant="label">Phone Number *</Typography>
                                                <PhoneInput
                                                    defaultCountry="in"
                                                    value={0}
                                                    onChange={(phone, country) => handlePhoneChange(phone, country)}
                                                    forceDialCode={true}
                                                    disableDialCodeEdit={true}
                                                    inputStyle={{
                                                        padding: "24px 12px",
                                                        width: "100%"
                                                    }}
                                                />
                                                {!isPhoneValid && (
                                                    <Typography variant="label" style={{
                                                        color: "#FF4842",
                                                        fontSize: "12px",
                                                        margin: "3px 14px 0px"
                                                    }}>
                                                        {phone ? "Please enter a valid phone number" : "Phone Number is required"}
                                                    </Typography>
                                                )}
                                            </Stack>
                                        </Box>
                                    }
                                    {/* <Box width={{ md: "50%", xs: "100%" }}>

                                <FormSelect label={"Citizenship *"} options={citizenshipOptions}
                                    props={{
                                        placeholder: "-- select --",
                                        ...getFieldProps("citizenShip"),
                                        error: Boolean(touched.citizenShip && errors.citizenShip),
                                        helperText: (touched.citizenShip && errors.citizenShip) || "*Restricted to indian nationals only",
                                        renderValue: values.citizenShip !== "" ? undefined : () => <Typography variant="placeHolder" sx={{ color: "text.disabled", fontSize: 14, }}>Select</Typography>
                                    }}
                                />
                            </Box> */}
                                    {/* <FormSelect label={"How should we address you? *"} options={genderOptions} 
                                props ={{
                                    placeholder:"select",
                                    ...getFieldProps("gender"),
                                    error:Boolean(touched.gender && errors.gender),
                                    helperText:touched.gender && errors.gender,
                                    renderValue:values.gender !== "" ? undefined :()=><Typography variant="placeHolder" sx={{color:"text.disabled",fontSize:14,}}>Select</Typography>
                                }}
                            /> */}

                                    <Box sx={{ width: { md: "50%", sm: "100%" } }}>
                                        <FormDatePicker
                                            sx={{ width: "100%" }}
                                            label="Date Of Birth *"
                                            disabledFuture={true}
                                            value={values.dob}
                                            minAge={18}
                                            onChange={(newValue) => {
                                                if (newValue && newValue.isValid()) {
                                                    const age = moment().diff(newValue, 'years');
                                                    if (age < 18) setFieldValue("dob", moment().subtract(18, "years"));
                                                    else setFieldValue("dob", newValue);
                                                }
                                            }}
                                        />
                                    </Box>
                                </Stack>
                                <Stack>
                                    <FormControl>
                                        <Box sx={{ width: { md: '48%', sm: '100%' }, boxShadow: 2, p: 1, borderRadius: 1 }}>
                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                <FormLabel id="toggle-buttons-group-label" sx={{ lineHeight: 1 }}>
                                                    <Typography className={style.citizenshipQuestion}>Are you Indian </Typography>
                                                </FormLabel>
                                                <ToggleButtonGroup value={formik.values.isIndian} exclusive onChange={handleIsIndian}>
                                                    <ToggleButton value="INDIAN" aria-label="Yes" className={`${style.citizenshipToggleBtn} ${formik.values.isIndian === "INDIAN" ? style.citizenshipToggleBtnSelected : ""}`}>
                                                        YES
                                                    </ToggleButton>
                                                    <ToggleButton value="FOREIGNER" aria-label="NO" className={`${style.citizenshipToggleBtn} ${formik.values.isIndian === "FOREIGNER" ? style.citizenshipToggleBtnSelected : ""}`}>
                                                        NO
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            </Stack>
                                        </Box>
                                    </FormControl>
                                </Stack>

                            </Stack>
                            {/* <Typography mt={5} variant="h4">Address Info *</Typography>
                    <Stack spacing={1.5} mt={3}>
                    <Stack direction={{md:"row",xs:"column"}} spacing={{md:3,xs:1.5}}>
                            <FormField 
                                label={"Pincode *"}
                                inputProps={{
                                    placeholder:"",
                                    ...getFieldProps("address.pinCode"),
                                    onBlur:getAddressFromPinCode,
                                    error:Boolean(touched.address?.pinCode && errors.address?.pinCode),
                                    helperText:touched.address?.pinCode && errors.address?.pinCode,
                                }}
                            />
                        </Stack>
                        <FormField 
                            label={"Flat No., House No., Company, Apartment *"}
                            inputProps={{
                                placeholder:"",
                                ...getFieldProps("address.house"),
                                error:Boolean(touched.address?.house && errors.address?.house),
                                helperText:touched.address?.house && errors.address?.house,
                            }}
                        />
                        <FormField 
                            label={"Area, Street, Sector, Village *"}
                            inputProps={{
                                placeholder:"",
                                ...getFieldProps("address.area"),
                                error:Boolean(touched.address?.area && errors.address?.area),
                                helperText:touched.address?.area && errors.address?.area,
                            }}
                        />
                        <FormField 
                            label={"Landmark*"}
                            inputProps={{
                                placeholder:"(Eg. Near Apollo Hospital)",
                                ...getFieldProps("address.landMark"),
                                error:Boolean(touched.address?.landMark && errors.address?.landMark),
                                helperText:touched.address?.landMark && errors.address?.landMark,
                            }}
                        />
                        <Stack direction={{md:"row",xs:"column"}} spacing={{md:3,xs:1.5}}>
                            <FormField 
                                label={"Town/City *"}
                                inputProps={{
                                    placeholder:"",
                                    ...getFieldProps("address.city"),
                                    error:Boolean(touched.address?.city && errors.address?.city),
                                    helperText:touched.address?.city && errors.address?.city,
                                }}
                            />
                            <FormSelect label={"State *"} options={stateOptions} 
                                props ={{
                                    ...getFieldProps("address.state"),
                                    error:Boolean(touched.address?.state && errors.address?.state),
                                    helperText:touched.address?.state && errors.address?.state,
                                    renderValue:values.address?.state !== "" ? undefined :()=><Typography variant="placeHolder" sx={{color:"text.disabled"}}>Select State</Typography>
                                }}
                            />
                        </Stack>
                    </Stack> */}
                            <LoadingButton loading={isSubmitting} type="submit"
                                variant="contained"
                                sx={{ mt: 5, width: { md: "auto", xs: "100%" } }}
                                loadingIndicator={
                                    <CircularProgress size={30} sx={{ color: 'red' }} />
                                }
                            >
                                Save And proceed
                            </LoadingButton>
                        </Form>
                    </FormikProvider>
                ) : (
                    <CitizenshipStatus handleClose={handleClose} setStep={setStep} user={user} enqueueSnackbar={enqueueSnackbar} dispatch={dispatch} setAnimating={setAnimating} setResidingInIndia={setResidingInIndia} residingInIndia={residingInIndia} />
                )}
        </Box>
    )
}

const CitizenshipStatus = ({ handleClose, setStep, user, enqueueSnackbar, dispatch, setAnimating }) => {
    const [userNotAllow, setUserNotAllow] = useState(false);
    const [showPanField, setShowPanField] = useState()


    const formik = useFormik({
        initialValues: {
            citizenShip: "INDIAN",
            havingPanCard: "",
            residingInIndia: "",
        },
        validationSchema: citizenShipSchema,
        onSubmit: (v, { resetForm }) => {
            saveDetails(v, { resetForm });
        },

    })

    const { errors, touched, handleSubmit, getFieldProps, values, setFieldValue, isSubmitting, setSubmitting } = formik;

    const saveDetails = async (values, { resetForm }) => {
        const havingPanCard = values.havingPanCard

        let data = {
            isPanCard: havingPanCard === "NO" ? "false" : "true",
            citizenShip: values.citizenShip,
            _id: user._id,
            status: havingPanCard === "NO" ? "FIRST_TIME" : "REGISTERED",
        };

        setSubmitting(true);
        const res = await authServices.updatePersonalDetails(data);
        setSubmitting(false);
        if (res.data.code === 409) {
            enqueueSnackbar(res.data.message, { variant: "error" });
            resetForm();
        } else if (res && res.success) {
            if (havingPanCard === "NO") {
                setUserNotAllow(true)

            }
            else {
                enqueueSnackbar("Personal details submitted", { variant: "success" });
                setAnimating(true)
            }

            dispatch(saveUser(res.data));
            resetForm();
        } else enqueueSnackbar(res?.data?.message || "Something went wrong!", { variant: "error", autoHideDuration: 4000 });
    }

    const handleIsResidingInIndia = (event, newValue) => {
        if (newValue !== null) {
            formik.setFieldValue("residingInIndia", newValue);
        }

        if ((user.citizenShip === "INDIAN" || user.citizenShip === "NRI") && newValue === "notResidingInIndia") {
            formik.setFieldValue("citizenShip", "NRI");
            formik.setFieldValue("havingPanCard", "");
            setShowPanField(true)

        }
        else if ((user.citizenShip === "INDIAN" || user.citizenShip === "NRI") && newValue === "residingInIndia") {
            formik.setFieldValue("citizenShip", "INDIAN");
            formik.setFieldValue("havingPanCard", "YES");
            setShowPanField(false)
        }
        else if (user.citizenShip === "FOREIGNER" && newValue === "notResidingInIndia") {
            formik.setFieldValue("citizenShip", "FOREIGNER");
            formik.setFieldValue("havingPanCard", "NO");
            setShowPanField(false)

        }
        else if (user.citizenShip === "FOREIGNER" && newValue === "residingInIndia") {
            formik.setFieldValue("citizenShip", "FOREIGNER");
            formik.setFieldValue("havingPanCard", "");
            setShowPanField(true)

        }
    }

    const handleHavingPanCard = (event, newValue) => {
        if (newValue !== null) {
            formik.setFieldValue("havingPanCard", newValue);

        }

    }

    const handlePanMsgClose = () => {
        setUserNotAllow(false)
    }

    const slideIn = keyframes`
        from{
            transform: translateX(-100%);
            opacity: 0;
            }
        to{
            transform: translateX(0);
            opacity: 1;
          }`;



    return (
        <Box mt={4}>
            <PanCardMessage handleClose={handleClose} open={userNotAllow} handlePanMsgClose={handlePanMsgClose} />
            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <Typography variant="h4">Enter Citizenship Info</Typography>
                    <Stack spacing={2} mt={3}>
                        <FormControl>
                            <Box sx={{ width: { md: '70%', sm: '100%' }, boxShadow: 2, p: 1, borderRadius: 1, animation: `${slideIn} 0.5s ease-out`, }}>
                                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                    <FormLabel id="toggle-buttons-group-label" sx={{ lineHeight: 1 }}>
                                        <Typography className={style.citizenshipQuestion} >Are you residing in India</Typography>
                                    </FormLabel>
                                    <ToggleButtonGroup color="primary" value={formik.values.residingInIndia} exclusive onChange={handleIsResidingInIndia}>
                                        <ToggleButton value="residingInIndia" aria-label="Yes" className={`${style.citizenshipToggleBtn} ${formik.values.residingInIndia === "residingInIndia" ? style.citizenshipToggleBtnSelected : ""}`}>
                                            YES
                                        </ToggleButton>
                                        <ToggleButton value="notResidingInIndia" aria-label="NO" className={`${style.citizenshipToggleBtn} ${formik.values.residingInIndia === "notResidingInIndia" ? style.citizenshipToggleBtnSelected : ""}`}>
                                            NO
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Stack>
                            </Box>
                            {formik.touched.residingInIndia && formik.errors.residingInIndia && (
                                <Typography sx={{ color: "red", fontSize: "0.75rem !important", marginTop: "4px" }}>
                                    {formik.errors.residingInIndia}
                                </Typography>
                            )}
                        </FormControl>
                        {showPanField && <FormControl>
                            <Box sx={{ width: { md: '70%', sm: '100%' }, boxShadow: 2, p: 1, borderRadius: 1, animation: `${slideIn} 0.5s ease-out`, }}>
                                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                    <FormLabel id="toggle-buttons-group-label" sx={{ lineHeight: 1 }} >
                                        <Typography className={style.citizenshipQuestion}> Do you have indian Pan card</Typography>
                                    </FormLabel>
                                    <ToggleButtonGroup color="primary" value={formik.values.havingPanCard} exclusive onChange={handleHavingPanCard}>
                                        <ToggleButton value="YES" aria-label="Yes" className={`${style.citizenshipToggleBtn} ${formik.values.havingPanCard === "YES" ? style.citizenshipToggleBtnSelected : ""}`}>
                                            YES
                                        </ToggleButton>
                                        <ToggleButton value="NO" aria-label="NO" className={`${style.citizenshipToggleBtn} ${formik.values.havingPanCard === "NO" ? style.citizenshipToggleBtnSelected : ""}`}>
                                            NO
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Stack>
                            </Box>
                            {formik.touched.havingPanCard && formik.errors.havingPanCard && (
                                <Typography sx={{ color: "red", fontSize: "0.75rem !important", marginTop: "4px" }}>
                                    {formik.errors.havingPanCard}
                                </Typography>
                            )}
                        </FormControl>}
                    </Stack>
                    <LoadingButton loading={isSubmitting} type="submit"
                        variant="contained"
                        sx={{ mt: 5, width: { md: "auto", xs: "100%" } }}
                        loadingIndicator={
                            <CircularProgress size={30} sx={{ color: 'red' }} />}>
                        Save And proceed
                    </LoadingButton>
                </Form>
            </FormikProvider>
        </Box>
    )
}


const KYCForm = ({ setStep, user, enqueueSnackbar, dispatch, handleClose, setAnimating, otp, setOtp, otpForm, refId, setRefId, setOtpForm, aadhaar, setAadhaar, openProgressBar, setOpenProgressBar, isIndian, residingInIndia, customHandleClose }) => {
    const [isManual, setIsManual] = useState(["NRI", "FOREIGNER"].includes(user.citizenShip) ? true : false);
    const [afterRejectedManual, setAfterRejectedManual] = useState(false);

    return (
        <Box>
            {!isManual && <Stack>
                <AutoKYCForm setIsManual={setIsManual} afterRejectedManual={afterRejectedManual} setStep={setStep} user={user} otp={otp} refId={refId} setRefId={setRefId} setOtp={setOtp} otpForm={otpForm} setOtpForm={setOtpForm} aadhaar={aadhaar} setAadhaar={setAadhaar} openProgressBar={openProgressBar} setOpenProgressBar={setOpenProgressBar} enqueueSnackbar={enqueueSnackbar} dispatch={dispatch} handleClose={handleClose} setAnimating={setAnimating} customHandleClose={customHandleClose} />
            </Stack>}
            {isManual && <Stack>
                <ManualKYCForm setIsManual={setIsManual} setAfterRejectedManual={setAfterRejectedManual} setStep={setStep} user={user} otp={otp} refId={refId} setRefId={setRefId} setOtp={setOtp} otpForm={otpForm} setOtpForm={setOtpForm} aadhaar={aadhaar} setAadhaar={setAadhaar} openProgressBar={openProgressBar} setOpenProgressBar={setOpenProgressBar} enqueueSnackbar={enqueueSnackbar} dispatch={dispatch} handleClose={handleClose} setAnimating={setAnimating} customHandleClose={customHandleClose} />
            </Stack>}
        </Box>
    );
}

const AutoKYCForm = ({ setIsManual, afterRejectedManual, setStep, user, enqueueSnackbar, dispatch, handleClose, setAnimating, otp, setOtp, otpForm, refId, setRefId, setOtpForm, aadhaar, setAadhaar, openProgressBar, setOpenProgressBar, customHandleClose }) => {

    const kycSchema = Yup.object().shape({
        panCardNumber: Yup.string().matches(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/, "Invalid PAN number format").required("PAN No. is required."),
        ifscCode: Yup.string()
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC format (11 characters: 4 letters, 0, then 6 alphanumeric)")
            .required("IFSC code is required."),
        accNumber: Yup.string()
            .matches(/^[0-9]{9,16}$/, "Account number must be 9 to 16 digits")
            .required("Account Number is required."),
        accType: Yup.string().when("validKyc", {
            is: true,
            then: schema => schema.required("Account Type is required."),
            otherwise: schema => schema.notRequired()
        }),
        bankCheque: Yup.mixed().nullable().when("validKyc", {
            is: true,
            then: schema => schema.required("Please upload this document.").test("FILE_SIZE", "File size must be below 5MB.", value => value && value.size <= VALID_FILE_SIZE)
                .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => value && SUPPORTED_FORMATS.includes(value.type)),
            otherwise: schema => schema.notRequired()
        }),
    })
    const [showBranch, setShowBranch] = useState("");
    const [isPanSubmitted, setPanSubmitted] = useState(false);
    const [panLoading, setPanLoading] = useState(false);
    const [isAdharVerified, setAdharVerified] = useState(false);
    const [isShowOPT, setOTPSection] = useState(false);
    const [validation, setValidation] = React.useState(kycSchema);
    const [validKyc, setValidIKyc] = useState(false)
    const [switchKyc, setSwitchKyc] = useState(false)
    const userId = useSelector((state) => state.user.data._id)
    const [errorMessage, setErrorMessage] = useState();
    const [timer, setTimer] = useState(0);
    const [disabled, setDisabled] = useState(true);
    const accTypeOptions = [
        {
            title: "Current account",
            value: "Current account",
        },
        {
            title: "Saving account",
            value: "Saving account",
        },
    ]

    const getBankFromIFSC = async () => {
        const code = values?.ifscCode;
        if (code && code.length === 11) {
            const res = await bankServices.getBankFromIFSCCode(code);
            if (res) {
                setShowBranch(`${res.BANK}, ${res.BRANCH}`);
            }
            else {
                setShowBranch("Not Found");
                setFieldError("ifscCode", "Not Found")
            }
        }
    }

    const submitAadhaar = async () => {
        const finalAadhaarNumber = aadhaarValues.join("");
        if (finalAadhaarNumber.length !== 12) {
            setOTPSection(false);
            enqueueSnackbar("Invalid Aadhaar Number", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, autoHideDuration: 5000 })
            return;
        } else {
            setAadhaar(finalAadhaarNumber);
        }

        // Your logic to handle submission
        setOpenProgressBar(true);

        try {
            const res = await authServices.submitAadhaar({ aadharNo: finalAadhaarNumber,userId });
            setOpenProgressBar(false);
            if (res && res.success) {
                setRefId(res.data.reference_id);
                setOTPSection(true);
                setTimer(120);
                setDisabled(true);
                enqueueSnackbar(res?.message?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, autoHideDuration: 4000 })
                logsService.addLog({
                    userId: user?._id,
                    event: InvestorActivityEventType.AADHAR_OTP_SENT
                })
            }
            else {
                setDisabled(false);
                setOTPSection(false);
                enqueueSnackbar(res?.data?.message || "Aadhar Number Not Found!", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, autoHideDuration: 4000 })
            }
        } catch (error) {
            enqueueSnackbar("Something went wrong", { variant: "error", autoHideDuration: 5000 })
        }
    }

    const verifyAadhaar = async () => {
        setOpenProgressBar(true);
        const finalAadhaarNumber = aadhaarValues.join("");
        const res = await authServices.verifyAadhaar({ aadhaar_otp: otp, reference_id: refId, userId: userId, aadharNo: finalAadhaarNumber })
        setOpenProgressBar(false);
        if (res && res.success) {
            dispatch(saveUser(res.data));
            setAdharVerified(true);
            enqueueSnackbar(res?.message?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, autoHideDuration: 4000 })
            logsService.addLog({
                userId: user?._id,
                event: InvestorActivityEventType.AADHAR_OTP_VERIFIED
            })
        }
        else {
            setAdharVerified(false);
            enqueueSnackbar(res?.data?.message || "Something went wrong!", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, autoHideDuration: 4000 })
        }
    }

    const formik = useFormik({
        initialValues: {
            panCardNumber: "",
            ifscCode: "",
            accNumber: "",
            accType: "",
            bankCheque: null,
            validKyc: validKyc,
            // addressProof:"",
            // panCard:null,
            // bankCheque:null,
            // addressProofFront:null,
            // addressProofBack:null,
            // bankInformation:{
            //     ifsc:"",
            //     accHolderName:"",
            //     accNumber:"",
            //     bank:"",
            //     accType:"",
            // },
        },
        validationSchema: validation,
        onSubmit: (v) => {
            submitKyc(v);
        },
    });

    const submitKyc = async (data) => {

        const formData = new FormData();
        Object.keys(data).forEach((key) => formData.append(key, data[key]));
        formData.append("isManual", validKyc);
        formData.append("investorId", user._id);
        formData.delete("accNumber");
        formData.append("bankAccNumber", data.accNumber)

        setSubmitting(true);
        setOpenProgressBar(true)

        try {
            const res = await authServices.completeKyc(formData);
            setSubmitting(false);
            setOpenProgressBar(false)
            if (res && res.success) {
                enqueueSnackbar("KYC details submitted", { variant: "success" });
                setAnimating(true)
                dispatch(saveUser(res.data));
                res.data.status == "KYC_COMPLETE" && customHandleClose()
                if(!validKyc){
                logsService.addLog({
                    userId: user?._id,
                    event: InvestorActivityEventType.PAN_AND_BANK_VERIFIED
                })
                }else{
                    logsService.addLog({
                        userId: user?._id,
                        event: InvestorActivityEventType.PAN_AND_BANK_SUBMITTED
                    })
                }
            }
            else {
                setSwitchKyc(true)
                setErrorMessage(res.data?.message)
                // console.log(res)
                enqueueSnackbar(res.data?.message || "Enter Correct Details", { variant: "error" });
            }
        } catch (error) {
            enqueueSnackbar("Something went wrong!", { variant: "error" });
        }
    }

    const { errors, touched, handleSubmit, getFieldProps, values, setFieldValue, setFieldError, handleBlur, isSubmitting, setSubmitting, setFieldTouched } = formik;

    const submitPan = async () => {
        const pan = values?.panCardNumber || "";
        await setFieldTouched("panCardNumber", true, true);
        try {
            await Yup.reach(kycSchema, "panCardNumber").validate(pan);
        } catch (err) {
            setFieldError("panCardNumber", err.message || "Invalid PAN number format");
            enqueueSnackbar(err.message || "Please enter a valid PAN number", {
                variant: "error",
                anchorOrigin: { horizontal: "right", vertical: "top" },
                autoHideDuration: 4000,
            });
            return;
        }

        setPanLoading(true);
        setOpenProgressBar(true);
        try {
            const res = await authServices.verifyPan({
                panCardNumber: pan,
                investorId:userId,
            });
            if (res && res.success) {
                setPanSubmitted(true);
                if (res.data) {
                    dispatch(saveUser(res.data));
                }
                enqueueSnackbar(res?.message || "PAN verified successfully. Please enter your Aadhaar number.", {
                    variant: "success",
                    anchorOrigin: { horizontal: "right", vertical: "top" },
                    autoHideDuration: 4000,
                });
            } else {
                enqueueSnackbar(res?.data?.message || res?.message || "PAN verification failed", {
                    variant: "error",
                    anchorOrigin: { horizontal: "right", vertical: "top" },
                    autoHideDuration: 5000,
                });
            }
        } catch (error) {
            enqueueSnackbar("Something went wrong while verifying PAN", {
                variant: "error",
                autoHideDuration: 5000,
            });
        } finally {
            setPanLoading(false);
            setOpenProgressBar(false);
        }
    }

    useEffect(() => {
        if (values.addressProof?.back) {
            let temp = validation.shape({
                addressProofBack: Yup.mixed().nullable().required("Please upload this document.").test("FILE_SIZE", "File size must be below 5MB.", value => value && value.size <= VALID_FILE_SIZE)
                    .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => value && SUPPORTED_FORMATS.includes(value.type)),
            })
            setValidation(temp);
        }
        else {
            setValidation(kycSchema);
        }
    }, [values.addressProof, validation])


    useEffect(() => {
        if (user?.aadharNumber) {
            setAdharVerified(true)
        } else if (user?.status === "REJECTED" && !afterRejectedManual) {
            setIsManual(true)
        }
    }, [user])



    const aadhaarRefs = [useRef(), useRef(), useRef()]; // Create refs for each box
    const [aadhaarValues, setAadhaarValues] = useState(["", "", ""]);
    const [aadhaarErrors, setAadhaarErrors] = useState([false, false, false]);
    
    const [frontSelectedImage, setFrontSelectedImage] = useState(null);
    const handleAadhaarChange = (index, value) => {
        if (/^\d*$/.test(value) && value.length <= 4) {
            setAadhaarValues((prevValues) => {
                const updatedValues = [...prevValues];
                updatedValues[index] = value;
                return updatedValues;
            });

            setAadhaarErrors((prevErrors) => {
                const updatedErrors = [...prevErrors];
                updatedErrors[index] = false;
                return updatedErrors;
            });

            if (value.length === 4 && index < 2) {
                aadhaarRefs[index + 1].current.focus();
            }
        } else {
            setAadhaarErrors((prevErrors) => {
                const updatedErrors = [...prevErrors];
                updatedErrors[index] = true;
                return updatedErrors;
            });
        }
    };
    const handleImageChange = (file, type) => {
        if (file) {
            // Assuming that "file" is a File object
            const reader = new FileReader();

            reader.onload = (e) => {
                // Set the selected image to the uploaded image
                if (type === "panImage") {
                    setFrontSelectedImage(e.target.result);
                }
                // } else if (type === "backImage") {
                //     setBackSelectedImage(e.target.result);
                // } else if (type === "panImage") {
                //     setPanSelectedImage(e.target.result);
                // }
            };

            reader.readAsDataURL(file);
        } else {
            // If no file is selected, clear the selected image
            // setFrontSelectedImage(null);
        }
    };

    return (
        <Box mt={4}>
            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <Stack direction={"row"} justifyContent={isAdharVerified ? "center" : "space-between"} alignItems={"center"}>
                        <Typography variant="h4" sx={{ fontSize: { xs: 10, sm: 14 }, }}>Enter Your Document Details</Typography>

                        {isAdharVerified == false && (
                            <Button
                                variant="outlined"
                                sx={{
                                    fontSize: { xs: 8, sm: 12 },
                                    height: { xs: 32, sm: 36 },   // Example height, adjust as needed
                                    minWidth: { xs: 110, sm: 140 }, // Example width, adjust as needed
                                    px: 2
                                }}
                                onClick={() => setIsManual(true)}
                            >
                                Switch to Manual KYC
                            </Button>
                        )}
                    </Stack>

                    <Stack spacing={1.5} mt={3} alignItems={'center'}>
                        <Stack
                            direction={{ md: "column", xs: "column" }}
                            spacing={{ md: 1, xs: 1.5 }}
                        >
                            {/* Step 1: PAN — hide after successful verification */}
                            {!isPanSubmitted && (
                                <Stack spacing={1} mt={1}>
                                    <Typography variant="label">PAN Card No. *</Typography>
                                    <Stack
                                        direction={{ md: "row", xs: "column" }}
                                        spacing={{ md: 2, xs: 1.5 }}
                                        alignItems={{ md: "center", xs: "stretch" }}
                                    >
                                        <FormField
                                            inputProps={{
                                                placeholder: "Enter PAN card number",
                                                ...getFieldProps("panCardNumber"),
                                                inputProps: { maxLength: 10 },
                                                onChange: (e) => {
                                                    setFieldValue("panCardNumber", sanitizePanInput(e.target.value));
                                                },
                                                error: Boolean(
                                                    touched.panCardNumber && errors.panCardNumber
                                                ),
                                                helperText: touched.panCardNumber && errors.panCardNumber,
                                                sx: {
                                                    '& .MuiInputBase-root': { minWidth: 0 },
                                                    minWidth: { lg: "420px !important", md: "320px !important", xs: "100%" }
                                                }
                                            }}
                                        />
                                        <LoadingButton
                                            loading={panLoading}
                                            onClick={submitPan}
                                            variant="contained"
                                            sx={{ alignSelf: { md: "center", xs: "stretch" }, whiteSpace: "nowrap" }}
                                        >
                                            Verify PAN
                                        </LoadingButton>
                                    </Stack>
                                </Stack>
                            )}

                            {/* Step 2: Aadhaar — only after PAN is submitted */}
                            {isPanSubmitted && !isAdharVerified && (
                                <Stack mt={3}>
                                    <Typography variant="label">Aadhaar Card No. *</Typography>
                                    <Stack direction="row" alignItems="center" spacing={{ sm: 2, xs: 1 }} mt={1} className="adharNoWrapper">
                                        {[0, 1, 2].map((index) => (
                                            <Box key={index}>
                                                <FormField
                                                    inputProps={{
                                                        value: aadhaarValues[index],
                                                        onChange: (e) => {
                                                            handleAadhaarChange(index, e.target.value);
                                                        },
                                                        onKeyDown: (e) => {
                                                            if (e.key === "Backspace" && index > 0 && !e.target.value) {
                                                                aadhaarRefs[index - 1].current.focus();
                                                            } else if (e.key >= "0" && e.key <= "9" && index < 2 && e.target.value.length === 4) {
                                                                aadhaarRefs[index + 1].current.focus();
                                                            }
                                                        },
                                                        inputRef: aadhaarRefs[index],
                                                        placeholder: "- - - -",
                                                        inputMode: "numeric",
                                                        error: aadhaarErrors[index] || (Boolean(touched[`aadhaar${index}`] && errors[`aadhaar${index}`])),
                                                        helperText: aadhaarErrors[index] ? "" : (touched[`aadhaar${index}`] && errors[`aadhaar${index}`]),
                                                        sx: {
                                                            '& .MuiInputBase-root': { minWidth: 0 },
                                                            maxWidth: { lg: "150px !important", md: "110px !important" },
                                                            '& .MuiInputBase-input': { textAlign: 'center' },
                                                            '& .MuiOutlinedInput-root': { padding: { xs: "12px 10px !important" } }
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        ))}

                                        <Button
                                            onClick={submitAadhaar}
                                            sx={{ marginTop: "8px !important" }}
                                            variant="contained"
                                            disabled={isAdharVerified}
                                        >
                                            Submit
                                        </Button>
                                    </Stack>
                                </Stack>
                            )}

                            {isPanSubmitted && isShowOPT && !isAdharVerified && (
                                <OTPForm
                                    otp={otp}
                                    setOtp={setOtp}
                                    setOtpForm={setOtpForm}
                                    verifyAadhaar={verifyAadhaar}
                                    resendOtp={submitAadhaar}
                                    timer={timer}
                                    setTimer={setTimer}
                                    disabled={disabled}
                                    setDisabled={setDisabled}
                                />
                            )}

                            {/* Step 3: Bank — only after Aadhaar is verified */}
                            {isAdharVerified && (
                                <Grid>
                                    <Stack
                                        direction={{ md: "row", xs: "column" }}
                                        spacing={{ lg: 2, md: 2, xs: 2 }}
                                        mt={{ sm: 2, xs: 2 }}
                                    >
                                        <FormField
                                            label={"Bank Account Number *"}
                                            inputProps={{
                                                placeholder: "Enter Account number (9-16 digits)",
                                                ...getFieldProps("accNumber"),
                                                inputProps: { inputMode: "numeric", maxLength: 16 },
                                                onChange: (e) => {
                                                    setFieldValue(
                                                        "accNumber",
                                                        sanitizeAccountNumberInput(e.target.value)
                                                    );
                                                },
                                                error: Boolean(
                                                    touched.accNumber &&
                                                    errors.accNumber
                                                ),
                                                helperText:
                                                    touched.accNumber &&
                                                    errors.accNumber,
                                            }}
                                        />

                                        <FormField
                                            label={"IFSC Code *"}
                                            inputProps={{
                                                placeholder: "Enter IFSC Code",
                                                ...getFieldProps("ifscCode"),
                                                inputProps: { maxLength: 11, style: { textTransform: "uppercase" } },
                                                onChange: (e) => {
                                                    setFieldValue("ifscCode", sanitizeIfscInput(e.target.value));
                                                },
                                                onBlur: (e) => {
                                                    handleBlur(e);
                                                    getBankFromIFSC();
                                                },
                                                error: Boolean(
                                                    touched.ifscCode &&
                                                    errors.ifscCode
                                                ),
                                                helperText:
                                                    (touched.ifscCode &&
                                                        errors.ifscCode) ||
                                                    showBranch,
                                            }}
                                        />
                                    </Stack>

                                    {validKyc && (
                                        <Stack
                                            direction={{ md: "row", xs: "column" }}
                                            spacing={{ md: 3, xs: 1.5 }}
                                            mt={{ sm: 4, xs: 2 }}
                                        >
                                            <FormSelect
                                                label={"Account Type *"}
                                                options={accTypeOptions}
                                                props={{
                                                    ...getFieldProps("accType"),
                                                    error: Boolean(
                                                        touched.accType &&
                                                        errors?.accType
                                                    ),
                                                    helperText:
                                                        touched?.accType &&
                                                        errors?.accType,
                                                }}
                                            />
                                            <FormFileField
                                                label={"Cancelled Cheque Image*"}
                                                accept={SUPPORTED_FORMATS}
                                                maxSize={VALID_FILE_SIZE}
                                                inputProps={{
                                                    error: Boolean(touched.bankCheque && errors.bankCheque),
                                                    helperText: touched.bankCheque && errors.bankCheque,
                                                    value: values.bankCheque,
                                                    onChange: (file) => setFieldValue("bankCheque", file),
                                                }}
                                            />
                                        </Stack>
                                    )}
                                </Grid>
                            )}
                        </Stack>
                    </Stack>
                    {switchKyc && validKyc == false && <Stack marginTop={"20px"}>
                        <Box sx={{ display: "flex", justifyContent: "center", color: "#e14545", borderRadius: "10px" }}>
                            {/* <Typography variant="body2" ></Typography> */}
                            <Typography variant="body2">Note: {errorMessage}, Please check enterd detail or switch to Manual KYC</Typography>
                        </Box>
                    </Stack>}

                    <Stack alignItems={'center'} >
                        {isAdharVerified &&

                            <Grid justifyContent={"center"} gap={2}>
                                {switchKyc && (
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            marginRight: "10px",
                                            mt: { sm: 3, xs: 2 },
                                            width: { md: "auto", xs: "100%" },
                                            marginTop: 3,  // Adjust spacing for this button
                                        }}
                                        onClick={() => {
                                            setValidIKyc(!validKyc)
                                            setFieldValue("validKyc", !validKyc)
                                        }}
                                    >

                                        {validKyc ? "Switch Back to Auto KYC" : "Proceed to Manual KYC"}
                                    </Button>
                                )}
                                <LoadingButton
                                    loading={isSubmitting}
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: { sm: 3, xs: 2 }, width: { md: "auto", xs: "100%" } }}
                                    loadingIndicator={<CircularProgress size={30} sx={{ color: 'red' }} />}
                                >
                                    Submit
                                </LoadingButton>


                            </Grid>

                        }
                    </Stack>

                </Form>
            </FormikProvider>
        </Box>
    );
}


const ManualKYCForm = ({ setAfterRejectedManual, setIsManual, setStep, user, enqueueSnackbar, dispatch, handleClose, setAnimating, setOpenProgressBar, customHandleClose }) => {

    const [showBranch, setShowBranch] = useState("");
    const [addressProf, setAddressProf] = useState("");
    // Hide PAN only when verified via Auto KYC (number saved, no Pan Card upload).
    // Manual KYC uploads include a Pan Card doc, so those fields stay visible for resubmit.
    // Auto-verified PAN stays hidden even if KYC is REJECTED.
    const panAlreadyTaken = Boolean(
        user?.panCardNumber &&
        !user?.documents?.find(doc => doc.docName === "Pan Card")
    );
    const [validation, setValidation] = React.useState(() => createManualKycSchema(panAlreadyTaken));
    const [panSelectedImage, setPanSelectedImage] = useState(null);
    const [frontSelectedImage, setFrontSelectedImage] = useState(null);
    const [backSelectedImage, setBackSelectedImage] = useState(null);
    const [checkImage, setCheckImage] = useState(null);
    const [documentProof, setDocumentProof] = useState();

    const userType = user.citizenShip

    const allAddressProofOptions = [
        {
            title: "Aadhar Card",
            label: "Aadhar Card",
            value: "Aadhar Card",
            back: true
        },
        {
            title: "Voter Card",
            label: "Voter Card",
            value: "Voter Card",
            back: false
        },
        {
            title: "Passport",
            label: "Passport",
            value: "Passport",
            back: true
        },
        {
            title: "Driving license",
            label: "Driving license",
            value: "Driving license",
            back: false
        },
    ];
    useEffect(() => {
        const docMapping = {
            "Aadhar Card Front": "Aadhar Card",
            "Voter Card Front": "Voter Card",
            "Passport Front": "Passport",
            "Driving license Front": "Driving license"
        };

        const selectedDoc = user?.documents?.find(doc => docMapping[doc.docName]);
        if (selectedDoc) {
            const baseName = docMapping[selectedDoc.docName];
            setAddressProf({
                name: baseName,
                url: user?.url + selectedDoc.path, // assuming 'path' holds the file name
            });
        }
    }, [user]);

    useEffect(() => {

        if (addressProf?.name === "Aadhar Card") {
            setDocumentProof({
                title: "Aadhar Card",
                label: "Aadhar Card",
                value: "Aadhar Card",
                back: true
            });
        } else if (addressProf?.name === "Voter Card") {
            setDocumentProof({
                title: "Voter Card",
                label: "Voter Card",
                value: "Voter Card",
                back: false
            });
        } else if (addressProf?.name === "Passport") {
            setDocumentProof({
                title: "Passport",
                label: "Passport",
                value: "Passport",
                back: true
            });
        } else if (addressProf?.name === "Driving license") {
            setDocumentProof({
                title: "Driving license",
                label: "Driving license",
                value: "Driving license",
                back: false
            });
        }
    }, [addressProf?.name]);


    const [addressProofOptions, setAddressProofOptions] = useState(allAddressProofOptions);

    const states = [
        'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
        'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
        'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
        'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
        'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', "Andaman and Nicobar Islands", "Chandigarh",
        "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep", "Delhi", "Puducherry", "Jammu and Kashmir", "Ladakh"
    ];

    const [stateOptions, setStateOptions] = useState(states)

    useEffect(() => {
        // Conditionally filter options
        if (userType === "NRI" || userType === "FOREIGNER") {
            setAddressProofOptions([
                {
                    title: "Passport",
                    label: "Passport",
                    value: "Passport",
                    back: true,
                },
            ]);
        } else {
            setAddressProofOptions(allAddressProofOptions);
        }
    }, [user.citizenShip]);


    const accTypeOptions = [
        {
            title: "Current account",
            value: "Current account",
        },
        {
            title: "Saving account",
            value: "Saving account",
        },
    ]

    const getBankFromIFSC = async () => {
        const code = values?.bankInformation?.ifsc;
        if (code && code.length === 11) {
            const res = await bankServices.getBankFromIFSCCode(code);
            if (res) {
                setShowBranch(`${res.BANK}, ${res.BRANCH}`);
                setFieldValue("bankInformation.bankName", res.BANK)
                setFieldValue("bankInformation.branch", res.BRANCH)
            }
            else {
                setShowBranch("Not Found");
                setFieldError("bankInformation.ifsc", "Not Found")
            }
        }
    }

    useEffect(() => {
        if (user && Object.keys(user)?.length > 0 && user?.documents?.length > 0) {
            const docFrontMapping = {
                "Aadhar Card Front": "Aadhar Card",
                "Voter Card Front": "Voter Card",
                "Passport Front": "Passport",
                "Driving license Front": "Driving license"
            };
            const docBackMapping = {
                "Aadhar Card Back": "Aadhar Card",
                "Passport Back": "Passport",
            };

            const selectedDocFrontUrl = user?.documents?.find(
                doc => docFrontMapping[doc?.docName]
            )?.docUrl;
            const selectedBackEndUrl = user?.documents?.find(
                doc => docBackMapping[doc?.docName]
            )?.docUrl;


            setFrontSelectedImage(user?.url + selectedDocFrontUrl)
            if (selectedBackEndUrl) {
                setBackSelectedImage(user?.url + selectedBackEndUrl)
            }

            setPanSelectedImage(user?.url + user?.documents?.find(doc => doc.docName === "Pan Card")?.docUrl);
            setCheckImage(user?.url + user?.documents?.find(doc => doc.docName === "Bank Cheque")?.docUrl);
        }
    }, [user]);

    const bankAccount = user?.bankAccount || [];
    const formik = useFormik({
        initialValues: {
            panCardNumber: sanitizePanInput(user?.panCardNumber || ""),
            passPortNumber: user?.passPortNumber || "",
            addressProof: documentProof || null,
            panCard: user?.documents?.find(doc => doc.docName === "Pan Card")?.docUrl
                ? { name: user?.documents?.find(doc => doc.docName === "Pan Card").docUrl }
                : null,
            bankCheque: user?.documents?.find(doc => doc.docName === "Bank Cheque")?.docUrl
                ? { name: user?.documents?.find(doc => doc.docName === "Bank Cheque").docUrl }
                : null,
            addressProofFront: user?.documents?.find(doc => doc.docName === "Aadhar Card Front" || doc.docName === "Voter Card Front" || doc.docName === "Passport Front" || doc.docName === "Driving license Front")?.docUrl
                ? { name: user?.documents?.find(doc => doc.docName === "Aadhar Card Front" || doc.docName === "Voter Card Front" || doc.docName === "Passport Front" || doc.docName === "Driving license Front").docUrl }
                : null,
            addressProofBack: user?.documents?.find(doc => doc.docName === "Aadhar Card Back" || doc.docName === "Passport Back")?.docUrl
                ? { name: user?.documents?.find(doc => doc.docName === "Aadhar Card Back" || doc.docName === "Passport Back").docUrl }
                : null,

            bankInformation: {
                ifsc: sanitizeIfscInput(bankAccount[0]?.ifsc || ""),
                accHolderName: bankAccount[0]?.accHolderName || "",
                accountNumber: sanitizeAccountNumberInput(
                    bankAccount[0]?.accountNumber != null ? String(bankAccount[0].accountNumber) : ""
                ),
                bankName: bankAccount[0]?.bankName || "",
                accountType: bankAccount[0]?.accountType || "",
            },
            userAddress: {
                flatNo: user?.userAddress?.flatNo || "",
                area: user?.userAddress?.area || "",
                landmark: user?.userAddress?.landmark || "",
                town: user?.userAddress?.town || "",
                state: user?.userAddress?.state || "",
                pincode: user?.userAddress?.pincode || ""
            }
        },
        enableReinitialize: true,
        validationSchema: validation,

        onSubmit: (v) => {
            submitKyc(v);
        },
    });

    const submitKyc = async (data) => {
        setOpenProgressBar(true);
        setSubmitting(true);
        try {
            const formData = new FormData();
            Object.keys((data)).map((key) => formData.append(key, data[key]));
            formData.delete("addressProof");
            formData.append("addressProof", data.addressProof.value);
            formData.delete("bankInformation");
            formData.append("bankInformation", JSON.stringify(data.bankInformation));
            formData.delete("userAddress");
            formData.append("userAddress", JSON.stringify(data.userAddress));
            formData.append("investorId", user._id);

            const res = await authServices.completeManualKyc(formData);
            if (res && res.success) {
                enqueueSnackbar("KYC details submitted", { variant: "success" });
                setAnimating(true);
                dispatch(saveUser(res.data));
                setTimeout(() => {
                    handleClose();
                }, 1500);
                customHandleClose();
                logsService.addLog({
                    userId: user?._id,
                    event: InvestorActivityEventType.MANUAL_KYC_SUBMITTED
                });
            } else {
                enqueueSnackbar(res?.message || res?.data?.message || "Something went wrong. Please try again.", { variant: "error" });
            }
        } catch (err) {
            enqueueSnackbar(err?.message || "Network error. Please try again.", { variant: "error" });
        } finally {
            setOpenProgressBar(false);
            setSubmitting(false);
        }
    }

    const { errors, touched, handleSubmit, getFieldProps, values, setFieldValue, setFieldError, handleBlur, isSubmitting, setSubmitting } = formik;

    useEffect(() => {
        const baseSchema = createManualKycSchema(panAlreadyTaken);
        if (values.addressProof?.back) {
            let temp = baseSchema.shape({
                addressProofBack: Yup.mixed()
                    .nullable()
                    .test("IS_FILE_OR_STRING", "Please upload this document.", value => {
                        if (!value) return false;
                        if (!(value instanceof File)) return true; // Skip if it's a string (existing file URL)
                        return true;
                    })
                    .test("FILE_SIZE", "File size must be below 5MB.", value => {
                        if (!value || !(value instanceof File)) return true;
                        return value.size <= VALID_FILE_SIZE;
                    })
                    .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => {
                        if (!value || !(value instanceof File)) return true;
                        return SUPPORTED_FORMATS.includes(value.type);
                    }),
            })
            setValidation(temp);
        }
        else {
            setValidation(baseSchema);
        }
    }, [values.addressProof, panAlreadyTaken])

    // const [panSelectedImage, setPanSelectedImage] = useState(null);

    const handleImageChange = (file, type) => {
        if (file) {
            // Assuming that "file" is a File object
            const reader = new FileReader();

            reader.onload = (e) => {
                // Set the selected image to the uploaded image
                if (type === "frontImage") {
                    setFrontSelectedImage(e.target.result);
                } else if (type === "backImage") {
                    setBackSelectedImage(e.target.result);
                } else if (type === "panImage") {
                    setPanSelectedImage(e.target.result);
                }
            };

            reader.readAsDataURL(file);
        } else {
            // If no file is selected, clear the selected image
            // setFrontSelectedImage(null);
        }
    };

    const fileSizeValidation = (file) => {
        if(file.size > VALID_FILE_SIZE) {
            enqueueSnackbar("File size must be below 5MB.", { variant: "error" });
            return false;
        }
        return true;
    }

    return (
        <Box mt={4}>
            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant="h4" sx={{ fontSize: { xs: 10, sm: 14 }, }}>Upload Your Documents</Typography>
                        {(userType !== "NRI" && userType !== "FOREIGNER") && (
                            <Button
                                variant="outlined"
                                sx={{ fontSize: { xs: 8, sm: 12 }, height: { xs: 32, sm: 36 }, minWidth: { xs: 110, sm: 140 }, px: 2 }}
                                onClick={() => {
                                    setIsManual(false)
                                    setAfterRejectedManual(true)
                                }}
                            >
                                Switch Back to Instant KYC
                            </Button>
                        )}


                        {/* {(useType !== "NRI" || useType !== "FOREIGNER") && (<Button variant="outlined" style={{mt: 3}} onClick={() => setIsManual(false)}>Switch Back to Instant KYC</Button>)} */}
                    </Stack>
                    <Stack spacing={1.5} mt={3}>
                        <Stack
                            direction={{ md: "row", xs: "column" }}
                            spacing={{ md: 3, xs: 1.5 }}
                        >


                            {!panAlreadyTaken && <Grid item md={6}>
                                <FormFileField
                                    label={"Upload PAN Card *"}
                                    accept={SUPPORTED_FORMATS}
                                    maxSize={VALID_FILE_SIZE}
                                    inputProps={{
                                        error: Boolean(touched.panCard && errors.panCard),
                                        helperText: touched.panCard && errors.panCard,
                                        value: values.panCard,
                                        onChange: (file) => {
                                            if(!fileSizeValidation(file)) {
                                                return;
                                            }
                                            setFieldValue("panCard", file)
                                            handleImageChange(file, "panImage");
                                        },
                                    }}
                                />

                                {/* Display the selected image in a square container */}

                                {panSelectedImage && (
                                    <div
                                        style={{
                                            width: "auto",
                                            height: "130px",
                                            border: "1px solid rgb(183 183 183)",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "6px",
                                            marginTop: "8px",
                                        }}
                                    >
                                        <img
                                            src={panSelectedImage}
                                            alt="Selected Image"
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </div>
                                )}
                            </Grid>}

                            <FormField
                                label={"Enter PAN Card No. *"}
                                inputProps={{
                                    placeholder: "",
                                    ...getFieldProps("panCardNumber"),
                                    inputProps: { maxLength: 10 },
                                    onChange: (e) => {
                                        setFieldValue("panCardNumber", sanitizePanInput(e.target.value));
                                    },
                                    error: Boolean(
                                        touched.panCardNumber && errors.panCardNumber
                                    ),
                                    helperText: touched.panCardNumber && errors.panCardNumber,
                                }}
                            />
                        </Stack>

                        <Stack
                            direction={{ md: "row", xs: "column" }}
                            spacing={{ md: 3, xs: 1.5 }}
                        >
                            <FormAutoCompleted
                                label={"Address Proof Document *"}
                                options={addressProofOptions}
                                props={{
                                    value: values.addressProof,
                                    onChange: (e, value) => {
                                        setFieldValue("addressProof", value);
                                        if (value !== documentProof) {
                                            // Clear address proof files if selected proof changes
                                            setFieldValue("addressProofFront", null);
                                            setFieldValue("addressProofBack", null);
                                            setFrontSelectedImage();
                                        }
                                    },
                                    options: addressProofOptions,
                                    error: Boolean(touched.addressProof && errors.addressProof),
                                    helperText: touched.addressProof && errors.addressProof,
                                }}
                            ></FormAutoCompleted>

                            {(userType === "NRI" || userType === "FOREIGNER") && <FormField
                                label={"Enter Passport No. *"}
                                inputProps={{
                                    placeholder: "",
                                    ...getFieldProps("passPortNumber"),
                                    error: Boolean(
                                        touched.passPortNumber && errors.passPortNumber
                                    ),
                                    helperText: touched.passPortNumber && errors.passPortNumber,
                                }}
                            />}
                        </Stack>

                        <Stack
                            direction={{ md: "row", xs: "column" }}
                            spacing={{ md: 3, xs: 1.5 }}
                        >
                            <Grid item md={6}>
                                <FormFileField
                                    label={"Upload Front Side *"}
                                    accept={SUPPORTED_FORMATS}
                                    maxSize={VALID_FILE_SIZE}
                                    inputProps={{
                                        error: Boolean(
                                            touched.addressProofFront && errors.addressProofFront
                                        ),
                                        helperText:
                                            touched.addressProofFront && errors.addressProofFront,
                                        value: values.addressProofFront,
                                        onChange: (file) => {
                                            if(!fileSizeValidation(file)) {
                                                return;
                                            }
                                            setFieldValue("addressProofFront", file);
                                            handleImageChange(file, "frontImage");
                                        },
                                    }}
                                />
                                {/* Display the selected image in a square container */}

                                {frontSelectedImage && (
                                    <div
                                        style={{
                                            width: "auto",
                                            height: "130px",
                                            border: "1px solid rgb(183 183 183)",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "6px",
                                            marginTop: "8px",
                                        }}
                                    >
                                        <img
                                            src={frontSelectedImage}
                                            alt="Selected Image"
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </div>
                                )}
                            </Grid>

                            <Grid item md={6}>
                                {(values.addressProof?.back) &&
                                    <FormFileField
                                        label={"Upload Back Side *"}
                                        accept={SUPPORTED_FORMATS}
                                        maxSize={VALID_FILE_SIZE}
                                        inputProps={{
                                            error: Boolean(
                                                touched.addressProofBack && errors.addressProofBack
                                            ),
                                            helperText:
                                                touched.addressProofBack && errors.addressProofBack,
                                            value: values.addressProofBack,
                                            onChange: (file) => {
                                                if(!fileSizeValidation(file)) {
                                                    return;
                                                }
                                                setFieldValue("addressProofBack", file);
                                                handleImageChange(file, "backImage");
                                            },
                                        }}
                                    />}

                                {backSelectedImage && (values.addressProof?.back) &&
                                    <div
                                        style={{
                                            width: "auto",
                                            height: "130px",
                                            border: "1px solid rgb(183 183 183)",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "6px",
                                            marginTop: "8px",
                                        }}
                                    >
                                        <img
                                            src={backSelectedImage}
                                            alt="Selected Image"
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </div>
                                }

                            </Grid>
                        </Stack>
                    </Stack>
                    <Typography mt={5} variant="h4">
                        Enter Bank Account Information
                    </Typography>
                    {userType === "NRI" &&
                        <Typography mt={1} variant="h5">
                            NRO Account Details (Mandatory)
                        </Typography>}

                    <Stack spacing={1.5} mt={3}>
                        <FormField
                            label={"Account Holder Name *"}
                            inputProps={{
                                ...getFieldProps("bankInformation.accHolderName"),
                                error: Boolean(
                                    touched.bankInformation?.accHolderName &&
                                    errors.bankInformation?.accHolderName
                                ),
                                helperText:
                                    touched.bankInformation?.accHolderName &&
                                    errors.bankInformation?.accHolderName,
                            }}
                        />

                        <Stack
                            direction={{ md: "row", xs: "column" }}
                            spacing={{ md: 3, xs: 1.5 }}
                        >
                            <FormField
                                label={"IFSC CODE *"}
                                inputProps={{
                                     placeholder: "Enter IFSC Code",
                                    ...getFieldProps("bankInformation.ifsc"),


                                    inputProps: { maxLength: 11, style: { textTransform: "uppercase" } },
                                    onChange: (e) => {
                                        setFieldValue(
                                            "bankInformation.ifsc",
                                            sanitizeIfscInput(e.target.value)
                                        );
                                    },
                                    onBlur: (e) => {
                                        handleBlur(e);
                                        getBankFromIFSC();
                                    },
                                    error: Boolean(
                                        touched.bankInformation?.ifsc &&
                                        errors.bankInformation?.ifsc
                                    ),
                                    helperText:
                                        (touched.bankInformation?.ifsc &&
                                            errors.bankInformation?.ifsc) ||
                                        showBranch,
                                }}
                            />




                            <FormField
                                label={"Account Number *"}
                                inputProps={{
                                    placeholder: "9-16 digits",
                                    ...getFieldProps("bankInformation.accountNumber"),
                                    inputProps: { inputMode: "numeric", maxLength: 16 },

                                    onChange: (e) => {
                                        setFieldValue(
                                            "bankInformation.accountNumber",
                                            sanitizeAccountNumberInput(e.target.value)
                                        );
                                    },
                                    error: Boolean(
                                        touched.bankInformation?.accountNumber &&
                                        errors.bankInformation?.accountNumber
                                    ),
                                    helperText:
                                        touched.bankInformation?.accountNumber &&
                                        errors.bankInformation?.accountNumber,
                                }}
                            />
                        </Stack>
                        <Stack
                            direction={{ md: "row", xs: "column" }}
                            spacing={{ md: 3, xs: 1.5 }}
                        >
                            {/* <FormSelect 
                                label={"Bank *"}
                                options={[]} 
                            /> */}
                            <FormSelect
                                label={"Account Type *"}
                                options={accTypeOptions}
                                props={{
                                    ...getFieldProps("bankInformation.accountType"),
                                    error: Boolean(
                                        touched.bankInformation?.accountType &&
                                        errors.bankInformation?.accountType
                                    ),
                                    helperText:
                                        touched.bankInformation?.accountType &&
                                        errors.bankInformation?.accountType,
                                }}
                            />
                            <FormFileField
                                label={"Cancelled Cheque Image*"}
                                accept={SUPPORTED_FORMATS}
                                maxSize={VALID_FILE_SIZE}
                                inputProps={{
                                    error: Boolean(touched.bankCheque && errors.bankCheque),
                                    helperText: touched.bankCheque && errors.bankCheque,
                                    value: values.bankCheque,
                                    onChange: (file) => {
                                        if(!fileSizeValidation(file)) {
                                            return;
                                        }
                                        setFieldValue("bankCheque", file);
                                    },
                                }}
                            />
                        </Stack>
                    </Stack>

                    <Typography mt={5} variant="h4">
                        Enter Address Information (As per ID Proof)
                    </Typography>
                    <Stack
                        direction={{ md: "row", xs: "column" }}
                        spacing={{ md: 3, xs: 1.5 }}
                    >
                        <FormField
                            label={"Flat No,House No *"}
                            inputProps={{
                                ...getFieldProps("userAddress.flatNo"),
                                error: Boolean(
                                    touched.userAddress?.flatNo &&
                                    errors.userAddress?.flatNo
                                ),
                                helperText:
                                    touched.userAddress?.flatNo &&
                                    errors.userAddress?.flatNo,
                            }}
                        />
                        <FormField
                            label={"Area,Street *"}
                            inputProps={{
                                ...getFieldProps("userAddress.area"),
                                error: Boolean(
                                    touched.userAddress?.area &&
                                    errors.userAddress?.area
                                ),
                                helperText:
                                    touched.userAddress?.area &&
                                    errors.userAddress?.area,
                            }}
                        />
                    </Stack>
                    <Stack
                        direction={{ md: "row", xs: "column" }}
                        spacing={{ md: 3, xs: 1.5 }}
                    >
                        <FormField
                            label={"Landmark"}
                            inputProps={{
                                ...getFieldProps("userAddress.landmark"),
                                error: Boolean(
                                    touched.userAddress?.landmark &&
                                    errors.userAddress?.landmark
                                ),
                                helperText:
                                    touched.userAddress?.landmark &&
                                    errors.userAddress?.landmark,
                            }}
                        />
                        <FormField
                            label={"Town/City *"}
                            inputProps={{
                                ...getFieldProps("userAddress.town"),
                                error: Boolean(
                                    touched.userAddress?.town &&
                                    errors.userAddress?.town
                                ),
                                helperText:
                                    touched.userAddress?.town &&
                                    errors.userAddress?.town,
                            }}
                        />
                    </Stack>
                    <Stack
                        direction={{ md: "row", xs: "column" }}
                        spacing={{ md: 3, xs: 1.5 }}
                    >
                        <FormAutoCompleted
                            label={"State *"}
                            options={stateOptions}
                            props={{
                                value: values.userAddress.state,
                                onChange: (e, value) => {
                                    setFieldValue("userAddress.state", value || "");
                                },
                                options: stateOptions,
                                error: Boolean(touched.userAddress?.state && errors.userAddress?.state),
                                helperText: touched.userAddress?.state && errors.userAddress?.state,
                            }}
                        ></FormAutoCompleted>
                        <FormField
                            label={"Pincode *"}
                            inputProps={{
                                ...getFieldProps("userAddress.pincode"),
                                error: Boolean(
                                    touched.userAddress?.pincode &&
                                    errors.userAddress?.pincode
                                ),
                                helperText:
                                    touched.userAddress?.pincode &&
                                    errors.userAddress?.pincode,
                            }}
                        />
                    </Stack>

                    <LoadingButton
                        loading={isSubmitting}
                        type="submit"
                        variant="contained"
                        sx={{ mt: 5, width: { md: "auto", xs: "100%" } }}
                    >
                        Submit
                    </LoadingButton>
                </Form>
            </FormikProvider>
        </Box>
    );
}



const OTPForm = ({ otp, setOtp, setOtpForm, verifyAadhaar, resendOtp,timer,setTimer,disabled,setDisabled }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [resendOtpDisabled, setResendOtpDisabled] = useState(false);

    useEffect(() => {
        let interval;
        if (timer > 0 && disabled) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setDisabled(false);
        }
        return () => clearInterval(interval);
    }, [timer, disabled]);

    const handleResendOtp = () => {
        setDisabled(true);
        if(resendOtpDisabled) {
            enqueueSnackbar("Please try after some time to resend OTP", { variant: "error" });
            return;
        }else{
            setResendOtpDisabled(true);
        }
        try {
            resendOtp();
        } catch (error) {
            enqueueSnackbar("Failed to resend OTP", { variant: "error" });
        }
    };

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${s.toString().padStart(2, '0')}`;
    };

    return (
        <Stack alignItems={'center'}>
            <Stack direction={"row"} mt={1} justifyContent={"space-between"}>
                <Typography variant="body2" sx={{ fontSize: 12 }}>OTP Sent To Your Registered Mobile Number</Typography>
            </Stack>
            <Stack spacing={1.5} mt={3}>
                <FormField label={"Enter OTP *"} inputProps={{
                    placeholder: "_ _ _ _ _ _",
                    type: "text",
                    value: otp,
                    onChange: (e) => {
                        if (RegExp('^[0-9]*$').test(e.target.value) && e.target.value?.length < 7) {
                            setOtp(e.target.value)
                        }
                    },
                    sx: { '& .MuiInputBase-root': { minWidth: 0, padding: "11px auto !important", textAlign: 'center' }, maxWidth: "250px !important", '& .MuiInputBase-input': { textAlign: 'center' } }
                }} />
            </Stack>
            <Stack direction={"row"} mt={2} spacing={1}>
                <Typography variant="body2" >Haven't received OTP?</Typography>
                {
                    disabled ?
                        <Typography variant="body2" sx={{ color: "primary.main", cursor: "disabled" }}>
                            Resend OTP in {formatTime(timer)}
                        </Typography>
                        :
                        <Typography onClick={() => handleResendOtp()} variant="body2" sx={{ color: "primary.main", cursor: resendOtpDisabled ? "not-allowed" : "pointer" }}>
                            Resend OTP
                        </Typography>
                }
            </Stack>
            <Stack alignItems={"center"} sx={{ width: '250px' }}>
                <Button onClick={verifyAadhaar} disabled={otp.length !== 6} variant="contained" sx={{ mt: 3 }}  >Verify OTP</Button>
            </Stack>
        </Stack>
    )
}
